import './PackUI.scss';
const PackUI = props => {
  const {
    label,
    price,
    quantity,
    isSelected,
    isShowBookingDate,
    bookingDate,
    coupon,
    fmCount,
    firstPaymentPrice,
    installmentCount,
    isInst,
  } = props || {};
  console.log('props', props, isInst);
  const packLabel = `${label} ${isShowBookingDate ? `for ${bookingDate}` : ''}`;
  let discountedPrice;
  let decimalPrice = parseFloat(price);
  decimalPrice = Number.isInteger(decimalPrice) ? decimalPrice : decimalPrice?.toFixed(2);
  decimalPrice = parseFloat(decimalPrice).toFixed(2);
  let show;
  let discountedFirstPayment;
  let discountedTotalPayment;
  if (coupon) {
    if (!props?.inst || props.inst?.allowDiscount == true) {
      show = true;
      discountedPrice = (price - (price * coupon?.percent) / 100)?.toFixed(2);
      if (firstPaymentPrice) {
        discountedFirstPayment = (firstPaymentPrice - (firstPaymentPrice * coupon?.percent) / 100)?.toFixed(2);
      }
      discountedTotalPayment = (decimalPrice - (decimalPrice * coupon?.percent) / 100)?.toFixed(2);
    }
  } else {
    show = false;
  }
  return (
    <div className="col">
      <div
        className={`card mb-4 rounded-3 shadow-sm ${isSelected ? 'selected' : ''}`}
        role="button"
        onClick={props._handleOnClick}
      >
        <div className="card-header py-3 bg-dark">
          <h4 className="my-0 fw-normal text-white fs-5 pack-card">{packLabel}</h4>
        </div>
        <div className="card-body">
          <h2
            className={
              'pricing-card-title mb-0' + (show && ' text-decoration-line-through text-danger')
            }
          >
            {(!props.isInst || (props.isInst && installmentCount <= 1)) && (
              <>
                ${decimalPrice}
              </>
            )}
          </h2>
          {props.isInst && installmentCount > 1 ? (
            <>
              <h2 className="pricing-card-title mb-0 font-size-18 text-align-left">
                {installmentCount} Payments
              </h2>
              {firstPaymentPrice && (
                <h2 className="pricing-card-title mb-0 font-size-18">
                  First Payment: ${show ? discountedFirstPayment : parseFloat(firstPaymentPrice).toFixed(2)}
                  {show && (
                    <span className="text-decoration-line-through text-danger ms-2">
                      ${parseFloat(firstPaymentPrice).toFixed(2)}
                    </span>
                  )}
                </h2>
              )}
              <h2 className="pricing-card-title mb-0 font-size-12 text-align-left fw-normal">
                Total Payments: ${show ? discountedTotalPayment : decimalPrice}
                {show && (
                  <span className="text-decoration-line-through text-danger ms-2">
                    ${decimalPrice}
                  </span>
                )}
              </h2>
              <p className="font-size-12">(includes all fees)</p>
            </>
          ) : (
            <p className="font-size-12">(includes all fees)</p>
          )}
          {(!props.isInst || (props.isInst && installmentCount <= 1)) && (
            <>
          {show && (
            <h2 className="pricing-card-title mb-0">
              {/* {props.isInst ? "$" + discountedPrice + "X" + fmCount : "$" + discountedPrice} */}
              ${discountedPrice}
            </h2>
          )}
          </>
          )}
          {quantity && (
            <ul className="list-unstyled mt-3 mb-4">
              <li className="p-1 border-bottom border-top">
                {`${quantity} Class${quantity > 1 ? 'es' : ''}`}
              </li>
            </ul>
          )}
        </div>
        {props.isInst && (
          <div className="card-footer" style={{ backgroundColor: '#2596be' }}>
            <div className="text-white fw-normal fs-5 ">
              {props.inst?.isInstallment ? (
                'Installment Payments'
              ) : (
                <span>
                  Single <br className="br-hide" />
                  Payment
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PackUI;
